export interface TooltipViewportOptions {
  /** ツールチップのおおよその幅（px）— .hero-tooltip の max-width に合わせる */
  estimatedWidth?: number;
  estimatedHeight?: number;
  offset?: number;
  padding?: number;
  viewportWidth?: number;
  viewportHeight?: number;
}

/**
 * カーソル付近に出す fixed ツールチップの left/top。右下はみ出し時は左／上に寄せる。
 */
export function adjustTooltipToViewport(
  clientX: number,
  clientY: number,
  opts?: TooltipViewportOptions
): { left: number; top: number } {
  const estimatedW = opts?.estimatedWidth ?? 200;
  const estimatedH = opts?.estimatedHeight ?? 132;
  const offset = opts?.offset ?? 12;
  const padding = opts?.padding ?? 10;
  const vw = opts?.viewportWidth ?? (typeof window !== 'undefined' ? window.innerWidth : 800);
  const vh = opts?.viewportHeight ?? (typeof window !== 'undefined' ? window.innerHeight : 600);

  let left = clientX + offset;
  let top = clientY + offset;

  if (left + estimatedW > vw - padding) {
    left = clientX - estimatedW - offset;
  }
  if (top + estimatedH > vh - padding) {
    top = clientY - estimatedH - offset;
  }

  const maxLeft = Math.max(padding, vw - estimatedW - padding);
  left = Math.max(padding, Math.min(left, maxLeft));
  const maxTop = Math.max(padding, vh - estimatedH - padding);
  top = Math.max(padding, Math.min(top, maxTop));

  return { left, top };
}
